import {
  CONFIRM_CART_LOT
} from './constants';
import { cloneDeep} from 'lodash'

export function confirmCarLot(selectedCarLots) {

    return (dispatch, getState) => {
      const { stock: { stocks } } = getState();
      const stockToProcess = cloneDeep(stocks.filter(stock => selectedCarLots.includes(stock.carLot)));
      const carLotNotSelected = stocks.filter(stock => !selectedCarLots.includes(stock.carLot));
      dispatch({
        type: CONFIRM_CART_LOT,
        data: { stockToProcess, carLotNotSelected }
      });
    }
  }

export function reducer(state, action) {
  if (action.type === CONFIRM_CART_LOT) {
      return {
        ...state,
        massiveUploadFile: null,
        carLotConfirmPending: false,
        currentStep: state.steps[state.currentStep.order + 1],
        stockToProcess: action.data.stockToProcess,
        carLotNotSelected: action.data.carLotNotSelected
      }
  }
  else {
      return state;
  }
}